import { Room } from 'matrix-js-sdk/src';
import moment from 'moment';

import { getMeetingByRoomId } from 'api/meedioBackend/getMeetingByRoomId';
import { getMeetingInvitations } from 'api/meedioBackend/getMeetingInvitations';

import { MINUTES_IN_UNIT } from '../AutoRemindersStepModal/utils';
import { Reminder } from '../CreateNewRoomDataProvider/utils';

export type CreateRoomProps = {
  roomName: string;
  isWaitingListEnabled: boolean;
  isPrivateRoom?: boolean;
  participants: string[];
  invitationMessage?: string;
  startsAt?: string | null;
  endsAt?: string | null;
  timeZone?: number;
  roomAlias?: string;
  description?: string;
};

export type UpdateRoomProps = CreateRoomProps & { room: Room };

export const getFullDateAt = (date: Date, time: Date, timeZone?: number) => {
  const timeMoment = moment(time);
  let combined = moment(date).set({ hour: timeMoment.hour(), minute: timeMoment.minute() });

  if (typeof timeZone === 'number') combined = combined.utcOffset(timeZone * 60, true);

  return combined.format('YYYY-MM-DD[T]HH:mm:ss.SSSZ');
};

export type InviteParticipant = {
  id: string;
  address: string;
  medium: string;
};

export const getInviteInformation = async (
  room: Room
): Promise<{ message: string; participants: InviteParticipant[] }> => {
  const meetingResponse = await getMeetingByRoomId(room.roomId);
  if (!meetingResponse) return { message: '', participants: [] };

  let participants: InviteParticipant[] = [];
  try {
    const invitations = await getMeetingInvitations(meetingResponse.id);
    participants = invitations
      .filter((inv) => inv.address)
      .map((inv) => ({
        id: inv.id,
        address: inv.address,
        medium: inv.medium,
      }));
  } catch {
    // Fall back to empty if endpoint unavailable
  }

  return { message: meetingResponse.message || '', participants };
};

export const getActiveRemindersIsoFormat = (reminders: Reminder[], eventStart: string) => {
  const activeReminders = reminders.filter(({ enabled }) => enabled);
  if (!activeReminders.length) return [];

  const eventStartParsed = moment.parseZone(eventStart);

  return activeReminders.map((reminder) => {
    const offsetMinutes = (reminder.amount || 0) * MINUTES_IN_UNIT[reminder.unit];
    const reminderMoment = eventStartParsed.clone().subtract(offsetMinutes, 'minutes');

    return reminderMoment.toISOString(true);
  });
};
